import React, { useState, useEffect } from 'react';
import { useUIContext } from '../../contexts/UIContext';
import pwaManager from '../../utils/pwa.js';
import offlineManager from '../../utils/offlineManager.js';
import logger from '../../utils/logger';

const PWAStatus = () => {
  const { showFeedback } = useUIContext();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [pwaStatus, setPwaStatus] = useState(null);
  const [offlineStatus, setOfflineStatus] = useState(null);
  // const [showInstallPrompt, setShowInstallPrompt] = useState(false); // DISABLED: Install prompt removed

  useEffect(() => {
    // Get PWA status
    const status = pwaManager.getInstallationStatus();
    setPwaStatus(status);

    // Get offline status
    const offline = offlineManager.getOfflineStatus();
    setOfflineStatus(offline);

    // Listen for online/offline changes
    const handleOnline = () => {
      setIsOnline(true);
      showFeedback('Back online!', 'success');
    };

    const handleOffline = () => {
      setIsOnline(false);
      showFeedback('You\'re offline. Some features may be limited.', 'warning');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // DISABLED: Install prompt removed - never show install prompt
    // if (status.canInstall && !status.isInstalled) {
    //   // Show install prompt after user has been engaged for a while
    //   setTimeout(() => {
    //     setShowInstallPrompt(true);
    //   }, 30000); // 30 seconds
    // }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [showFeedback]);

  // DISABLED: Install prompt handlers removed
  // const handleInstall = async () => {
  //   try {
  //     await pwaManager.installApp();
  //     setShowInstallPrompt(false);
  //     showFeedback('App installed successfully!', 'success');
  //   } catch (error) {
  //     logger.error('App', 'Installation failed:', error);
  //     showFeedback('Installation failed. Please try again.', 'error');
  //   }
  // };

  // const handleDismissInstall = () => {
  //   setShowInstallPrompt(false);
  // };

  if (!pwaStatus || !offlineStatus) {
    return null;
  }

  return (
    <>
      {/* Online/Offline Status Indicator */}
      <div className={`fixed top-4 right-4 z-50 transition-all duration-300 ${
        isOnline ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}>
        <div className="bg-yellow-500 text-white px-3 py-2 rounded-lg shadow-lg flex items-center space-x-2">
          <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
          <span className="text-sm font-medium">Offline</span>
        </div>
      </div>

      {/* DISABLED: Install Prompt removed - never show install prompt */}
      {/* {showInstallPrompt && (
        <div className="fixed bottom-4 left-4 right-4 z-50 max-w-sm mx-auto">
          <div className="bg-white rounded-xl shadow-xl border border-gray-200 p-4">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-gray-900">
                  Install KinsThread
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  Get quick access and learn offline with the KinsThread app.
                </p>
                <div className="flex space-x-2 mt-3">
                  <button
                    onClick={handleInstall}
                    className="bg-green-500 text-white px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-green-600 transition-colors"
                  >
                    Install
                  </button>
                  <button
                    onClick={handleDismissInstall}
                    className="text-gray-500 px-3 py-1.5 text-sm font-medium hover:text-gray-700 transition-colors"
                  >
                    Not now
                  </button>
                </div>
              </div>
              <button
                onClick={handleDismissInstall}
                className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )} */}

      {/* PWA Status Debug (only in development) */}
      {process.env.NODE_ENV === 'development' && (
        <div className="fixed bottom-4 right-4 z-50 bg-black bg-opacity-75 text-white p-2 rounded text-xs">
          <div>PWA: {pwaStatus.isInstalled ? 'Installed' : 'Not Installed'}</div>
          <div>Online: {isOnline ? 'Yes' : 'No'}</div>
          <div>SW: {pwaStatus.hasServiceWorker ? 'Active' : 'Inactive'}</div>
        </div>
      )}
    </>
  );
};

export default PWAStatus;


